import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Dropdown, Message } from 'semantic-ui-react'

import './RoundSelector.css'

class RoundSelector extends PureComponent {
  onRoundChange = (_, { value }) => {
    const { stages } = this.props
    const rounds = []
    stages.map((stage) => stage.rounds.forEach((round) => rounds.push(round)))
    const round = rounds.find((s) => s.id === value)
    this.props.onChange(round)
  }

  render() {
    const { printable, round, stages } = this.props
    const options = []

    stages.forEach((stage) =>
      stage.rounds.forEach((sround) => {
        options.push({
          key: sround.id,
          text: `${stage.name} - ${sround.name}`,
          value: sround.id,
        })
      }),
    )

    if (options.length) {
      if (printable) {
        const option = options.find((o) => o.key === round.id)
        return <h4>{option.text}</h4>
      }
      return (
        <Dropdown
          className="RoundSelector__dropdown"
          fluid
          name="RoundSelection"
          onChange={this.onRoundChange}
          options={options}
          placeholder="Fases"
          search={options.length >= 30}
          selection
          value={round ? round.id : ''}
        />
      )
    }

    return (
      <Message className="RoundSelector__message" color="yellow" size="mini">
        Torneo sin Fases.
      </Message>
    )
  }
}

RoundSelector.propTypes = {
  onChange: PropTypes.func,
  printable: PropTypes.bool,
  round: PropTypes.object,
  stages: PropTypes.array.isRequired,
}

RoundSelector.defaultProps = {
  onChange: Function.prototype,
  printable: false,
  round: null,
}

export default RoundSelector
